import { observable, IObservableValue } from 'mobx';
import { PayerOnboardingPage } from '../index';
import { FormField } from '../../../WebGiving/components/form-field';
import { ValidationState, validateFields } from '../../../WebGiving/validation/view-model-validator';
import { PayerOnboardingPageViewModelBase } from '../payer-onboarding-page-view-model';
import { createRulesFromMetadata } from '../../../WebGiving/validation/validation-rules';
import { ModelMetadata } from '../../payer-onboarding-generated';

export class PageConfirmMobileNumberViewModel extends PayerOnboardingPageViewModelBase {
	readonly type: PayerOnboardingPage.ConfirmMobileNumber = PayerOnboardingPage.ConfirmMobileNumber;
	securityCode: FormField<string>;

	@observable
	validationState?: ValidationState;

	validate(): ValidationState {
		return validateFields(this);
	}

	constructor(
		public mobileNumber: string,
		public resendCodeDisabled: IObservableValue<boolean>,
	) {
		super();
		this.securityCode = new FormField<string>('', createRulesFromMetadata(ModelMetadata.ConfirmCodeAndUpdateDetailsRequest.Code));
	}
}
